// src/utils/socket.js
import { io } from 'socket.io-client';
import { SERVER_URL } from './config';

console.log("🔌 Tentative de connexion Socket vers :", SERVER_URL);

const socket = io(SERVER_URL, {
    transports: ['websocket', 'polling'],
    withCredentials: true
});

// Petit bonus de sécurité pour tracer les erreurs dans ta console
socket.on('connect_error', (err) => {
    console.error('❌ Erreur de connexion au serveur Socket :', err.message);
});

export default socket;